import { ReactNode } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import { PRIMARY } from 'constants/colors';
import { Icon } from '@sdb/planning-ui';

const StyledAccordion = styled(Accordion)`
  box-shadow: unset !important;

  &::before {
    display: none;
  }

  &.MuiPaper-root {
    background-color: transparent;
  }

  .MuiAccordionSummary-root {
    padding: 0;
    background: linear-gradient(
      90deg,
      ${PRIMARY} 0%,
      rgba(0, 177, 170, 0) 100%
    );
    background-size: 100% 2px;
    background-repeat: repeat-x;
    background-position: center;
    box-sizing: content-box;
    justify-content: flex-start;
    padding-left: 25px;
  }

  .MuiAccordionSummary-content {
    margin: 0;
    flex-grow: 0;
    background-color: var(--mui-palette-background-default);
    position: relative;
    padding-left: 12px;

    &::after {
      content: '';
      position: absolute;
      background-color: var(--mui-palette-background-default);
      width: calc(100% + 40px);
      left: 0;
      height: 100%;
      top: 0;
      z-index: 1;
    }

    h3 {
      position: relative;
      z-index: 2;
      margin-bottom: 0;
    }
  }

  .MuiAccordionSummary-expandIconWrapper {
    margin-left: 10px;
    position: relative;
    z-index: 2;
    margin-right: 12px;
  }

  .MuiAccordionDetails-root {
    padding: 0;
  }
`;

type Props = {
  summary: string;
  children: ReactNode;
  onSelected?: () => void;
} & AccordionProps;

export default function CustomAccordion({
  disableGutters,
  summary,
  children,
  className,
  onSelected,
  defaultExpanded,
  ...rest
}: Props) {
  return (
    <StyledAccordion
      disableGutters={disableGutters}
      square
      {...rest}
      defaultExpanded={defaultExpanded}
      className={classNames('custom-accordion', className)}
    >
      <AccordionSummary
        expandIcon={<Icon type="chevron-down" fontSize="small" />}
        onClick={onSelected}
      >
        <h3>{summary}</h3>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
}
